import { Link } from "react-router-dom";
import FaqAccordion from "./FaqAccordion";
import { subcategoryGuide } from "../lib/subcategoryGuides.mjs";

export function SubcategoryGuide({ subSlug }) {
  const g = subcategoryGuide(subSlug);
  if (!g) return null;
  return (
    <section className="mt-10 space-y-6" data-testid={`subcategory-guide-${subSlug}`}>
      <div className="bg-white border border-slate-200 p-6 lg:p-8">
        <div className="overline mb-2">Buyer's guide</div>
        <h2 className="font-display font-black text-2xl text-kolt-slate-dark tracking-tight">{g.h1}</h2>
        <p className="text-sm text-slate-700 mt-3 leading-relaxed">{g.intro}</p>
        <div className="grid md:grid-cols-2 gap-6 mt-6">
          {g.sections.map((s) => (
            <div key={s.h}>
              <h3 className="font-bold text-kolt-slate-dark">{s.h}</h3>
              <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-3 mt-6">
          {(g.ctas || [{ to: "/quote?rush=1", label: "Request a rush quote", primary: true }]).map((c) => (
            <Link key={c.to} to={c.to} className={c.primary ? "btn-primary" : "px-5 py-3 border border-slate-300 hover:border-kolt-slate-dark font-mono text-[11px] tracking-[0.22em] uppercase font-bold"} data-testid={`subcategory-guide-cta-${c.to.replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "")}`}>{c.label}</Link>
          ))}
        </div>
      </div>
      <FaqAccordion items={g.faqs} heading={g.faqHeading || "Frequently asked questions"} />
    </section>
  );
}
